/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { RichText } from "cms/rich-text";
import { RichTextImage } from "cms/shared/images/rich-text-image";
import { ImageLinkItem } from "cms/components/image-link/image-link-item";

const HighlightComponent = (props) => {

    const { component } = props || {};
    const {
        description,
        image,
        image_links: imageLinks,
        section_name,
        subtitle,
        title
    } = component || {};

    const hasImageLinks = imageLinks && imageLinks.length > 0;

    return (
        <div className="simplicity-highlight-wrapper">
            <div className='highlight-text-content'>
                {section_name && <h4>{section_name}</h4>}
                {title && <h2>{title}{subtitle && <span>{` ${subtitle}`}</span>}</h2>}
                <div className="rich-text-wrap">
                    <RichText richtext={description} />
                </div>
                {hasImageLinks &&
                    <div className='highlight-image-link-items'>
                        {imageLinks.map((item, index) => (
                            <ImageLinkItem item={item} key={`highlight-image-link-item-${index}`} />
                        ))}
                    </div>}
            </div>
            {image && (
                <div className='simplicity-richtext-wrap-image'>
                    <RichTextImage image={image} />
                </div>
            )}
        </div>
    );
};

HighlightComponent.displayName = "HighlightComponent";
export { HighlightComponent };
